module.exports = __webpack_public_path__ + "static/img/case_detail_10_2.0a48108.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_detail_10_2.png
// module id = Iyqo
// module chunks = 34